export enum FiQuizQuestionType {
    SingleAnswer = 0,
    MultipleAnswers = 1,
}

export enum FiQuizNotificationRecipientType {
    //todo almost copypaste with FiOnboardingStepNotificationRecipientType
    Roles = 0,
    RolesLocal = 1,
    Users = 2,
    EmailAddress = 3,
    SMS = 4,
}

export enum FiQuizEditorTabIndex {
    QuizEditor = 0,
    SettingsSharing = 1,
}
